import type { ReactNode } from "react";
import { StyleSheet, View } from "react-native";

import { spacing } from "~/styles/theme";

export function Row({
  children,
  between = false,
}: {
  children: ReactNode;
  between?: boolean;
}) {
  return (
    <View style={[stylesheet.row, between ? stylesheet.between : null]}>
      {children}
    </View>
  );
}

const stylesheet = StyleSheet.create({
  row: { flexDirection: "row", alignItems: "center", gap: spacing.s },
  between: { justifyContent: "space-between" },
});
